import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { canUseCompanySection, companySectionForPath } from '@/lib/company-access';
import { useCompanyRole } from '@/hooks/useCollegeRole';
import { RoleRestrictedNotice } from '@/components/layouts/RoleRestrictedNotice';

/** Layout route around every /company page; see CollegeSectionGate. */
export const CompanySectionGate: React.FC = () => {
  const { pathname } = useLocation();
  const { role, permissions } = useCompanyRole();
  const section = companySectionForPath(pathname);

  if (section && role && !canUseCompanySection(role, section, permissions)) {
    return <RoleRestrictedNotice homeTo="/company/dashboard" adminLabel="a company admin" />;
  }
  return <Outlet />;
};
